import { render } from "./SocialSection.vue?vue&type=template&id=3176b44a"
import script from "./SocialSection.vue?vue&type=script&lang=js"
export * from "./SocialSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__